var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',_vm._g(_vm._b({attrs:{"label":"","outlined":"","color":_vm.color}},'v-chip',_vm.$attrs,false),_vm.$listeners),[_c('span',[_vm._v(_vm._s((_vm.value || "").toUpperCase()))]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }